import * as types from '../../lib/actionTypes.es6';

export var initialState = {
  listTypes: [],
  listTypesLoader: false,
  lists: {},
  listsLoader: {},
  error: null,
};

export default function coverLinkSettings(state, action) {
  if (state === undefined) state = initialState;

  var listType, newLists, newListsLoader;

  switch (action.type) {

    case types.GET_LOOKUP_LIST_TYPES_REQUEST:
      return Object.assign({}, state, { listTypesLoader: true, listTypes: [], error: null });

    case types.GET_LOOKUP_LIST_TYPES_SUCCESS:
      return Object.assign({}, state, { listTypesLoader: false, listTypes: action.payload });

    case types.GET_LOOKUP_LIST_TYPES_FAILURE:
      return Object.assign({}, state, { listTypesLoader: false, error: action.payload });

    case types.GET_LOOKUP_LIST_REQUEST:
      listType = action.payload;
      newListsLoader = Object.assign({}, state.listsLoader);
      newListsLoader[listType] = true;
      newLists = Object.assign({}, state.lists);
      newLists[listType] = [];
      return Object.assign({}, state, { listsLoader: newListsLoader, lists: newLists, error: null });

    case types.GET_LOOKUP_LIST_SUCCESS:
      listType = action.payload.listType;
      newListsLoader = Object.assign({}, state.listsLoader);
      newListsLoader[listType] = false;
      newLists = Object.assign({}, state.lists);
      newLists[listType] = action.payload.data;
      return Object.assign({}, state, { listsLoader: newListsLoader, lists: newLists });

    case types.GET_LOOKUP_LIST_FAILURE:
      listType = action.payload.listType;
      newListsLoader = Object.assign({}, state.listsLoader);
      newListsLoader[listType] = false;
      return Object.assign({}, state, { listsLoader: newListsLoader, error: action.payload.error });

    case types.ADD_LOOKUP_LIST_ITEM_SUCCESS:
    case types.UPDATE_LOOKUP_LIST_ITEM_SUCCESS:
    case types.DELETE_LOOKUP_LIST_ITEM_SUCCESS:
      listType = action.payload.listType;
      newLists = Object.assign({}, state.lists);
      newLists[listType] = action.payload.data;
      return Object.assign({}, state, { lists: newLists });

    case types.ADD_LOOKUP_LIST_ITEM_FAILURE:
    case types.UPDATE_LOOKUP_LIST_ITEM_FAILURE:
    case types.DELETE_LOOKUP_LIST_ITEM_FAILURE:
      return Object.assign({}, state, { error: action.payload.error });

    default:
      return state;
  }
}
